<ng-container *ngIf="addFormLoader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
<mat-card class="MainThemeBody" [class.leftmenusmall]="isActive">
    <div class="topLogo"><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/broko_v1_logo.png" alt="#">
    </div>
    <mat-card class="dashboardBody">
        <aside class="leftmenuBody">
            <app-leftmenu></app-leftmenu>
        </aside>

        <section class="dashboarSection">
            <section class="dashboarMainWrapper">
                <header class="MainHeader">
                    <div class="arrow_leftBTN" (click)="toggleActive()"><mat-icon>keyboard_arrow_left</mat-icon></div>
                    <app-header></app-header>
                </header>

                <div class="mainTitle">
                    <h1>Edit Profile   </h1>

                    <p>A user profile is a collection of information about an individual who uses a particular service, website, or application, such as their name, email address, password, preferences, activity history, location data, etc.</p>


                </div>


                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!--====================== common block start======================-->
                <div class="bodyWrapper">

                    <!--====================== dynamic block start======================-->

                    <div class="myaccountpage">
                        <div class="myaccountpageLeft">
                            <span>ACCOUNT</span>
                            <ul>

                                <li><a> Public Profile</a></li>
                                <li><a> Account Settings</a></li>
                                <li><a> Privacy Settings</a></li>
                                <li><a> Login & Security</a></li>
                                <li><a>Notifications</a></li>
                                <li><a>Connections</a></li>
                                <li><a> Billing Info</a></li>
                            </ul>


                        </div>

                        <div class="addEditForm">

                            <div class="mainTitlesub">
                                <h1> Account Settings</h1>
            
                                <p>Here, users can update their profile details, change their password and adjust their preferences for email notifications and account security settings, among other options. It provides a convenient and user-friendly interface for users to easily manage their account details.</p>
            
            
                            </div>

                            <lib-showform class=" addEditFormblock" [formdata]="formdata"
                                [formfieldrefresh]="formfieldrefresh" [formfieldrefreshdata]="formfieldrefreshdata"
                                (onFormFieldChange)="listenFormFieldChange($event)">
                            </lib-showform>

                            <ng-container *ngIf="addFormLoader">
                                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                            </ng-container>

                        </div>

                    </div>


                    <!--====================== dynamic block end ======================-->
                </div>

                <!--====================== common block end======================-->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->


            </section>

            <footer class="MainFooter"><app-footer></app-footer></footer>

        </section>


    </mat-card>

</mat-card>